import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Paper,
  Typography,
  ListItem,
  List,
  ListItemText
} from '@material-ui/core';
import { convertUTCDateToLocalDate } from 'helpers/date';
import {makeStyles} from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import { BackdropCircular } from 'components';
import { getOrderShipmentsApi } from '../../api';


const useStyles = makeStyles({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
});


const OrderShippingData = ({ order }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    customer_firstname,
    customer_lastname,
    billing_address: { firstname, lastname },
    entity_id,
  } = order;

  const { loadingOrderShipments, orderShipments } =  useSelector((state: IReduxState) => state.store_orders);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    getOrderShipmentsApi({dispatch, orderId: entity_id});
  }, [entity_id]);

  const handleChange = (id: string) => {
    setExpanded((prevState) => (prevState !== id ? id : null));
  };

  const shipments = orderShipments[entity_id] || [];

  return (
    <div className="m-8">
      {!shipments.length ? (
        <Typography component="h2" align="center">
          There is no shipping information
        </Typography>
      ) : (shipments.map((item, index) => {
        const { comments, entity_id, items, tracks, created_at } = item;
        return (
          <Accordion
            key={index}
            onChange={() => handleChange(item.entity_id)}
            expanded={expanded === entity_id}
          >
            <>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Typography>{item.increment_id}</Typography>
              </AccordionSummary>
              <Divider />
            </>
            <Divider />
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper>
                    <Box p={2} className={classes.bgBlue}>
                      <Typography component="h3" align="center">Ship Date:</Typography>
                      <Typography align="center">
                        {convertUTCDateToLocalDate(created_at).toLocaleString(
                          'en-US',
                          {
                            dateStyle: 'medium',
                            timeStyle: 'short'
                          }
                        )}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper>
                    <Box p={2} className={classes.bgBlue}>
                      <Typography component="h3" align="center">Ship To Name:</Typography>
                      <Typography align="center">
                        {firstname || customer_firstname} {lastname || customer_lastname}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper>
                    <Box p={2} className={classes.bgBlue}>
                      <Typography component="h3" align="center">Carrier</Typography>
                      <Typography align="center">
                        {tracks.length ? tracks[0].title : '---'}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper>
                    <Box p={2} className={classes.bgBlue}>
                      <Typography component="h3" align="center">Tracking Number</Typography>
                      <Typography align="center">{tracks.length ? tracks[0].track_number : '---'}</Typography>
                    </Box>
                  </Paper>
                </Grid>
                {items.length &&
                  <Grid item xs={12}>
                    <TableContainer component={Paper}>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="m-2 p-2">Item</TableCell>
                            <TableCell className="m-2 p-2">QTY</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {items.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell className="m-2 p-2">{item.name}</TableCell>
                              <TableCell className="m-2 p-2">{item.qty}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                }
                {comments.length !== 0 &&
                  <Grid item xs={12} className={`${classes.bgBlue} m-2 p-2`}>
                    <Typography component="h3">Comments:</Typography>
                    {comments.map((item, index) => (
                      <List dense key={index}>
                        <ListItem>
                          <ListItemText
                            primary={item.comment}
                          />
                        </ListItem>
                      </List>
                    ))}
                  </Grid>
                }
              </Grid>
            </AccordionDetails>
            <BackdropCircular loading={loadingOrderShipments} />
          </Accordion>
        );
      }))}
    </div>
  );
};

export default OrderShippingData;
